import { Component } from '@angular/core';
import { GermplasmNameSettingModel } from '../../shared/germplasm/model/germplasm-name-setting.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { GermplasmCodeNameType } from '../../shared/germplasm/model/germplasm-code-name-batch-request.model';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
    selector: 'jhi-germplasm-coding',
    templateUrl: './germplasm-coding-dialog.component.html'
})
export class GermplasmCodingDialogComponent {

    GermplasmCodeNameType = GermplasmCodeNameType;

    gids: number[];
    automaticNaming: boolean;
    nameType: GermplasmCodeNameType = GermplasmCodeNameType.CODE1;
    isProcessing: boolean;
    germplasmCodeNameSetting: GermplasmNameSettingModel = new GermplasmNameSettingModel();
    numberOfDigits = Array(9).fill(1).map((x, i) => i + 1);
    nextCodeNameSequence: string;

    constructor(private modal: NgbActiveModal,
                private germplasmService: GermplasmService,
                private alertService: AlertService) {
        this.automaticNaming = true;
        this.germplasmCodeNameSetting.addSpaceBetweenPrefixAndCode = false;
        this.germplasmCodeNameSetting.addSpaceBetweenSuffixAndCode = false;
        this.germplasmCodeNameSetting.numOfDigits = 1;
    }

    close() {
        this.modal.close();
    }

    applyCodes() {
        this.isProcessing = true;
        this.germplasmService.createGermplasmCodeNames({
            gids: this.gids,
            nameType: this.nameType,
            germplasmCodeNameSetting: this.automaticNaming ? null : this.germplasmCodeNameSetting
        }).toPromise().then((result) => {
            this.modal.close(result);
        }).finally(() => {
            this.isProcessing = false;
        });
    }

    validate() {
        return this.automaticNaming || (this.germplasmCodeNameSetting.prefix && this.germplasmCodeNameSetting.numOfDigits);
    }

    getNextNameSequence() {
        if (this.germplasmCodeNameSetting.prefix) {
            this.germplasmService.getNextNameInSequence(this.germplasmCodeNameSetting).toPromise().then((response) => {
                if (response.body) {
                    this.nextCodeNameSequence = response.body;
                }
            });
        }
    }

}
